import { cn } from '@/shadcn-ui/utils';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { colors } from '@/theme/colors';

export default function FlexcarLogoWhite({
  className,
  fillPrimary = colors.neutral100,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[40px] w-[41px]', className)}
    >
      <g clipPath="url(#clip0_5398_19381)">
        <path
          d="M21.0186 0.00683594C31.8267 0.280485 40.5039 9.12783 40.5039 20.002L40.498 20.5176C40.2244 31.3257 31.3769 40.0028 20.5029 40.0029L19.9863 39.9971C9.34978 39.7276 0.777117 31.1542 0.507812 20.5176L0.500977 20.002C0.500977 8.95534 9.45631 0 20.5029 0L21.0186 0.00683594ZM20.5029 2.5C10.837 2.5 3.00098 10.336 3.00098 20.002C3.00113 29.6677 10.8371 37.5029 20.5029 37.5029C30.1686 37.5028 38.0038 29.6676 38.0039 20.002C38.0039 10.3361 30.1687 2.50015 20.5029 2.5ZM29.9727 30.9668C30.0238 31.0506 30.0537 31.1461 30.0596 31.2441C30.0476 31.4038 29.974 31.5527 29.8545 31.6592C29.735 31.7656 29.5788 31.8209 29.4189 31.8145H24.9971C24.4833 31.8144 24.1526 31.3076 24.0625 31.1475L21.5234 26.8096L24.5264 21.6904L29.9727 30.9668ZM16.0137 8.20215C16.5276 8.20215 16.8581 8.70661 16.9482 8.87012L23.4854 20.002L16.9482 31.1445C16.8611 31.292 16.527 31.8115 16.0137 31.8115H11.583C11.4234 31.818 11.2674 31.7618 11.1484 31.6553C11.0295 31.5488 10.9566 31.4004 10.9453 31.2412C10.9495 31.1495 10.9762 31.0597 11.0225 30.9805L17.4824 20.002L11.0283 9.04688C10.9793 8.96478 10.9511 8.8718 10.9453 8.77637C10.9565 8.61679 11.0296 8.4674 11.1484 8.36035C11.2673 8.25352 11.4233 8.19658 11.583 8.20215H16.0137ZM29.4189 8.18848C29.5775 8.18278 29.7325 8.238 29.8516 8.34277C29.9707 8.44767 30.0452 8.59482 30.0596 8.75293C30.0539 8.84369 30.0264 8.93183 29.9795 9.00977L24.5264 18.3066L21.5234 13.1943L24.0527 8.85645C24.1428 8.70962 24.4734 8.18848 24.9873 8.18848H29.4189Z"
          fill={fillPrimary}
        />
      </g>
      <defs>
        <clipPath id="clip0_5398_19381">
          <rect
            width="40"
            height="40"
            fill={fillPrimary}
            transform="translate(0.500977)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
